import { Avatar, AvatarProps } from '../Avatar';
import { liquidityProviderFallbackMatch, liquidityProviderLogos } from './liquidityProviderLogos';

export type LiquidityProviderAvatarProps = AvatarProps & {
  /**
   * Name of the liquidity provider to display the logo for.
   */
  name: string;
};

export const liquiditySourceAvatarRadius = '32%';

const normalizeLiquidityProviderName = (name: string) =>
  name.replaceAll(' ', '_').replaceAll('-', '_').toLowerCase();

export const getLiquidityProviderLogo = (name: string): string | undefined => {
  const normalizedName = normalizeLiquidityProviderName(name);
  const directLogo = liquidityProviderLogos[normalizedName];

  if (directLogo) {
    return directLogo;
  }

  const matchedProvider = Object.entries(liquidityProviderFallbackMatch).find(([, match]) =>
    match.test(normalizedName),
  )?.[0];

  return matchedProvider;
};

export const LiquidityProviderAvatar = (props: LiquidityProviderAvatarProps) => {
  const { name, size = 20, ...otherProps } = props;

  const logoName = getLiquidityProviderLogo(name);
  const src = logoName ? `/images/liquidity-providers/${logoName}.png` : undefined;

  return (
    <Avatar src={src} radius={liquiditySourceAvatarRadius} size={size} {...otherProps}>
      <div
        className="flex items-center justify-center bg-token-gray-200"
        style={{ width: size, height: size }}
      >
        <p className="text-token-gray-1000">{name.charAt(0).toUpperCase()}</p>
      </div>
    </Avatar>
  );
};
